import { render, staticRenderFns } from "./ClassRatingStatus.vue?vue&type=template&id=2068034b&scoped=true"
import script from "./ClassRatingStatus.vue?vue&type=script&lang=js"
export * from "./ClassRatingStatus.vue?vue&type=script&lang=js"
import style0 from "./ClassRatingStatus.vue?vue&type=style&index=0&id=2068034b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2068034b",
  null
  
)

export default component.exports